import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { DeleteOperationsPayment, OperationsPayment } from '../../models/operations-payment.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class OperationsPaymentService {
  private readonly API = `${environment.api_url}/PagamentoOperacao`;

  constructor(private http: HttpClient) {}

  operationsPayment(data: Date): Observable<OperationsPayment[]> {
    return this.http.get<OperationsPayment[]>(
      `${this.API}/GetPagamentoOperacao/${data.toISOString().split('T')[0]}` // Format date to YYYY-MM-DD
    );
  }

  delete(body: DeleteOperationsPayment): Observable<void> {
    return this.http.delete<void>(`${this.API}/DeleteMarked`, {
      body,
    });
  }
}
